import { HomePage } from "./../home/home";
import { PlazaSelectPlanPage } from "./../plaza-select-plan/plaza-select-plan";
import { TranslateService } from "@ngx-translate/core";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-ticket-social",
  templateUrl: "plaza-ticket-social.html",
})
export class PlazaTicketSocialPage {
  space: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    this.space = this.navParams.data.space;
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // console.log('ionViewDidLoad PlazaTicketSocialPage');
  }

  confirm() {
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      let body = "";

      var link = this.services.URLUpdateSocial + this.space.space_no + "/stock";
      var headers = new Headers();
      headers.append("Content-Type", "application/x-www-form-urlencoded");
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .post(link, body, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            loader.dismiss();
            this.navCtrl.push(PlazaSelectPlanPage);
          },
          (error) => {
            var response = JSON.parse(error._body);
            loader.dismiss();
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }
  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-ticket-social/plaza-ticket-social.ts